<template>
  <div>

    <div style="background-color: #f1f1f1;">
      <div>
        <div style="height: 40px; display: flex;">
          <!--                {this.timeSelectViewOne()}-->
          <div v-for="(item, index) in selectTimeListOne" :key="index">
            <template v-if="timeIndexOne === index">
              <div class="selectButton" style="background-color: #0079d5;">
                <span style="color: #fff">{{ item }}</span>
              </div>
            </template>
            <template v-else>
              <div class="selectButton" @click="selectTimeOne(index)">
                <span style="color: #333">{{ item }}</span>
              </div>
            </template>
          </div>
        </div>
        <div style="height: 40px; display: flex;">
          <!--                {this.timeSelectViewTwo()}-->
          <div v-for="(item, index) in selectTimeListTwo" :key="index">
            <template v-if="timeIndexTwo === index">
              <div class="selectButton" style="background-color: #0079d5;">
                <span style="color: #fff">{{ item.dateValue }}</span>
              </div>
            </template>
            <template v-else>
              <div class="selectButton" @click="selectTimeTwo(index, item)">
                <span style="color: #333">{{ item.dateValue }}</span>
              </div>
            </template>
          </div>
        </div>

        <div class="scroll">
          <div class="dbfxBox">

            <div class="dbfxDataBox" style="left: 410px;top: 10px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">净资产收益率</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.returnOnEquity.subjectValStr }}</span>
              </div>
            </div>

            <!-- --------------------------------------------------------------------------------------------------------------- -->
            <div class="dbfxLineY" style="left: 474px; top: 60px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 314px; top: 70px; width: 482px;"></div>
            <div class="dbfxLineY" style="left: 314px; top: 70px; height: 10px;"></div>
            <div class="dbfxLineY" style="left: 539px; top: 70px; height: 10px;"></div>
            <div class="dbfxLineY" style="left: 794px; top: 70px; height: 10px;"></div>

            <div class="dbfxDataBox" style="left: 250px; top: 80px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800">总资产净利率</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.profitMarginOfTotalAssets.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 393px; top: 80px">
              <span class="dbfxSymbol">×</span>
            </div>

            <div class="dbfxDataBox" style="left: 430px; top: 80px; width: 220px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">归属母公司股东的净利润占比</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.netProfitOfParentCompany.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 677px; top: 80px;">
              <span class="dbfxSymbol">×</span>
            </div>

            <div class="dbfxDataBox" style="left: 730px; top: 80px">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800">权益乘数</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.equityMultiplier.subjectValStr }}</span>
              </div>
            </div>

            <!-- --------------------------------------------------------------------------------------------------------------- -->
            <div class="dbfxLineY" style="left: 314px; top: 130px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 154px; top: 140px; width: 322px;"></div>
            <div class="dbfxLineY" style="left: 154px; top: 140px; height: 10px;"></div>
            <div class="dbfxLineY" style="left: 474px; top: 140px; height: 10px;"></div>
            <div class="dbfxLineY" style="left: 794px; top: 130px; height: 20px;"></div>

            <div class="dbfxDataBox" style="left: 90px; top: 150px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800">营业净利润</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.netOperatingMargin.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 303px; top: 150px;">
              <span class="dbfxSymbol">×</span>
            </div>

            <div class="dbfxDataBox" style="left: 410px; top: 150px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">总资产周转率</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.turnoverOfTotalAssets.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 620px; top: 150px;">
              <span class="dbfxSymbol">1÷(1-</span>
            </div>

            <div class="dbfxDataBox" style="left: 730px; top: 150px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-Weight: 800;">资产负债率</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.assetLiabilityRatio.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 865px; top: 150px;">
              <span class="dbfxSymbol">)</span>
            </div>

            <!-- --------------------------------------------------------------------------------------------------------------- -->
            <div class="dbfxLineY" style="left: 154px; top: 200px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 74px; top: 210px; width: 162px;"></div>
            <div class="dbfxLineY" style="left: 74px; top: 210px; height: 10px;"></div>
            <div class="dbfxLineY" style="left: 234px; top: 210px; height: 10px;"></div>

            <div class="dbfxLineY" style="left: 474px; top: 200px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 394px; top: 210px; width: 162px;"></div>
            <div class="dbfxLineY" style="left: 394px; top: 210px; height: 10px;"></div>
            <div class="dbfxLineY" style="left: 554px; top: 210px; height: 10px;"></div>

            <div class="dbfxLineY" style="left: 794px; top: 200px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 714px; top: 210px; width: 162px;"></div>
            <div class="dbfxLineY" style="left: 714px; top: 210px; height: 10px;"></div>
            <div class="dbfxLineY" style="left: 874px; top: 210px; height: 10px;"></div>

            <div class="dbfxDataBox" style="left: 10px; top: 220px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">净利润</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.netProfit.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 142px; top: 220px;">
              <span class="dbfxSymbol">÷</span>
            </div>

            <div class="dbfxDataBox" style="left: 170px; top: 220px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">营业总收入</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.grossOperatingIncome.subjectValStr }}</span>
              </div>
            </div>

            <div class="dbfxDataBox" style="left: 330px; top: 220px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">营业总收入</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.grossOperatingIncome.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 462px; top: 220px;">
              <span class="dbfxSymbol">÷</span>
            </div>

            <div class="dbfxDataBox" style="left: 490px; top: 220px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">平均资产总额</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.averageTotalAssets.subjectValStr }}</span>
              </div>
            </div>

            <div class="dbfxDataBox" style="left: 650px; top: 220px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">平均负债总额</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.averageTotalLiabilities.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 782px; top: 220px;">
              <span class="dbfxSymbol">÷</span>
            </div>

            <div class="dbfxDataBox" style="left: 810px; top: 220px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">平均资产总额</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.averageTotalAssets.subjectValStr }}</span>
              </div>
            </div>

            <!-- --------------------------------------------------------------------------------------------------------------- -->
            <div class="dbfxLineY" style="left: 74px; top: 270px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 74px; top: 280px; width: 162px;"></div>
            <div class="dbfxLineY" style="left: 74px; top: 280px; height: 11px;"></div>
            <div class="dbfxLineY" style="left: 234px; top: 280px; height: 11px;"></div>

            <div class="dbfxLineY" style="left: 554px; top: 270px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 554px; top: 280px; width: 162px;"></div>
            <div class="dbfxLineY" style="left: 554px; top: 280px; height: 11px;"></div>
            <div class="dbfxLineY" style="left: 714px; top: 280px; height: 11px;"></div>

            <div class="dbfxDataBox" style="left: 10px; top: 290px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">收入总额</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.totalRevenue.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 142px; top: 290px;">
              <span class="dbfxSymbol">-</span>
            </div>

            <div class="dbfxDataBox" style="left: 170px; top: 290px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">成本总额</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.totalCost.subjectValStr }}</span>
              </div>
            </div>

            <div class="dbfxDataBox" style="left: 490px; top: 290px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">平均流动资产</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.averageCurrentAssets.subjectValStr }}</span>
              </div>
            </div>

            <div style="position: absolute; left: 621px; top: 290px;">
              <span class="dbfxSymbol">+</span>
            </div>

            <div class="dbfxDataBox" style="left: 650px; top: 290px;">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValueText" style="font-weight: 800;">平均非流动资产</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValueText">{{ selectData.averageNonCurrentAssets.subjectValStr }}</span>
              </div>
            </div>

            <!-- --------------------------------------------------------------------------------------------------------------- -->
            <div class="dbfxLineY" style="left: 74px; top: 340px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 2px; top: 350px; width: 150px;"></div>

            <div class="dbfxLineY" style="left: 234px; top: 340px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 162px; top: 350px; width: 308px;"></div>

            <div class="dbfxLineY" style="left: 554px; top: 340px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 485px; top: 350px; width: 145px;"></div>

            <div class="dbfxLineY" style="left: 714px; top: 340px; height: 11px;"></div>
            <div class="dbfxLineX" style="left: 645px; top: 350px; width: 304px;"></div>

            <!-- 收入总额 -->
            <div class="dbfxLineY" :style="{ left: '2px', top: '350px', height: lineYHeightNum1 + 'px' }"></div>
            <div class="dbfxLineY" :style="{ left: '150px', top: '350px', height: lineYHeightNum1 + 'px' }"></div>
            <div class="dbfxLineX" :style="{ left: '2px', top: lineXTopNum1 + 'px', width: '150px' }"></div>

            <div v-for="(item, index) in selectData.totalRevenue.duPontFormulaInfoEleList" :key="'tr-' + index"
              class="dbfxDataBox" :style="{ left: '10px', top: (360 + (index * 50) - index) + 'px' }">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{ item.subjectName }}</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValuespan">{{ item.subjectValStr }}</span>
              </div>
            </div>

            <div class="dbfxDataBox" :style="{ height: '21px', left: '10px', top: topEndNum1 + 'px' }">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValuespan" style="font-weight: 800;">···</span>
              </div>
            </div>

            <!-- 成本总额 -->
            <div class="dbfxLineY" :style="{ left: '162px', top: '350px', height: lineYHeightNum2 + 'px' }"></div>
            <div class="dbfxLineY" :style="{ left: '470px', top: '350px', height: lineYHeightNum2 + 'px' }"></div>
            <div class="dbfxLineX" :style="{ left: '162px', top: lineXTopNum2 + 'px', width: '310px' }"></div>

            <div v-for="(item, index) in selectData.totalCost.duPontFormulaInfoEleList" :key="'tc-' + index"
              class="dbfxDataBox" :style="{ left: '170px', top: (360 + (index * 50) - index) + 'px' }">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{ item.subjectName }}</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValuespan">{{ item.subjectValStr }}</span>
              </div>
            </div>

            <div class="dbfxDataBox" :style="{ height: '21px', left: '170px', top: topEndNum2 + 'px' }">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValuespan" style="font-weight: 800;">···</span>
              </div>
            </div>

            <div class="dbfxDataBox" :style="{ left: '330px', top: '360px' }">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{ periodExpenses2.subjectName }}</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValuespan">{{ periodExpenses2.subjectValStr }}</span>
              </div>
            </div>

            <div v-if="perExpList2.length > 0">
              <div class="dbfxLineY" :style="{ left: '395px', top: '410px', height: '10px' }"></div>
              <div class="dbfxLineX" :style="{ left: '328px', top: '418px', width: '138px' }"></div>
              <div class="dbfxLineY" :style="{ left: '328px', top: '420px', height: perLineYHeightNum2 + 'px' }"></div>
              <div class="dbfxLineY" :style="{ left: '464px', top: '420px', height: perLineYHeightNum2 + 'px' }"></div>
              <div class="dbfxLineX" :style="{ left: '328px', top: perLineXTopNum2 + 'px', width: '138px' }"></div>

              <div v-for="(item, index) in perExpList2" :key="'pe-' + index" class="dbfxDataBox"
                :style="{ left: '330px', top: (420 + (index * 50) - index) + 'px' }">
                <div class="dbfxDataBoxTitle">
                  <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{ item.subjectName }}</span>
                </div>
                <div class="dbfxDataBoxValue">
                  <span class="dbfxDataBoxValuespan">{{ item.subjectValStr }}</span>
                </div>
              </div>
            </div>

            <!-- 平均流动资产 -->
            <div class="dbfxLineY" :style="{ left: '483px', top: '350px', height: lineYHeightNum3 + 'px' }"></div>
            <div class="dbfxLineY" :style="{ left: '630px', top: '350px', height: lineYHeightNum3 + 'px' }"></div>
            <div class="dbfxLineX" :style="{ left: '483px', top: lineXTopNum3 + 'px', width: '149px' }"></div>

            <div v-for="(item, index) in selectData.averageCurrentAssets.duPontFormulaInfoEleList" :key="'ac-' + index"
              class="dbfxDataBox" :style="{ left: '490px', top: (360 + (index * 50) - index) + 'px' }">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{ item.subjectName }}</span>
              </div>
              <div class="dbfxDataBoxValue">
                <span class="dbfxDataBoxValuespan">{{ item.subjectValStr }}</span>
              </div>
            </div>

            <div class="dbfxDataBox" :style="{ height: '21px', left: '490px', top: topEndNum3 + 'px' }">
              <div class="dbfxDataBoxTitle">
                <span class="dbfxDataBoxValuespan" style="font-weight: 800;">···</span>
              </div>
            </div>

            <!-- 平均非流动资产 -->
            <div class="dbfxLineY" :style="{ left: '643px', top: '350px', height: lineYHeightNum4 + 'px' }"></div>
            <div class="dbfxLineY" :style="{ left: '948px', top: '350px', height: lineYHeightNum4 + 'px' }"></div>
            <div class="dbfxLineX" :style="{ left: '643px', top: lineXTopNum4 + 'px', width: '307px' }"></div>

            <div v-for="(item, index) in selectData.averageNonCurrentAssets.duPontFormulaInfoEleList"
              :key="'nc-' + index">

              <template v-if="index % 2 == 1"></template>

              <template
                v-else-if="(index + 1 < selectData.averageNonCurrentAssets.duPontFormulaInfoEleList.length) && (index + 1 == selectData.averageNonCurrentAssets.duPontFormulaInfoEleList.length - 1)">
                <div class="dbfxDataBox" :style="{ left: '650px', top: 360 + ((index / 2) * 50) - (index / 2) + 'px' }">
                  <div class="dbfxDataBoxTitle">
                    <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index].subjectName }}</span>
                  </div>
                  <div class="dbfxDataBoxValue">
                    <span class="dbfxDataBoxValuespan">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index].subjectValStr }}</span>
                  </div>
                </div>
                <div class="dbfxDataBox" :style="{ left: '810px', top: 360 + ((index / 2) * 50) - (index / 2) + 'px' }">
                  <div class="dbfxDataBoxTitle">
                    <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index + 1].subjectName }}</span>
                  </div>
                  <div class="dbfxDataBoxValue">
                    <span class="dbfxDataBoxValuespan">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index + 1].subjectValStr }}</span>
                  </div>
                </div>
                <div class="dbfxDataBox" :style="{ height: '21px', left: '650px', top: topEndNum4 + 'px' }">
                  <div class="dbfxDataBoxTitle">
                    <span class="dbfxDataBoxValuespan" style="font-weight: 800;">···</span>
                  </div>
                </div>
              </template>

              <template
                v-else-if="(index + 1 < selectData.averageNonCurrentAssets.duPontFormulaInfoEleList.length) && (index + 1 != selectData.averageNonCurrentAssets.duPontFormulaInfoEleList.length - 1)">
                <div class="dbfxDataBox" :style="{ left: '650px', top: 360 + ((index / 2) * 50) - (index / 2) + 'px' }">
                  <div class="dbfxDataBoxTitle">
                    <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index].subjectName }}</span>
                  </div>
                  <div class="dbfxDataBoxValue">
                    <span class="dbfxDataBoxValuespan">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index].subjectValStr }}</span>
                  </div>
                </div>
                <div class="dbfxDataBox" :style="{ left: '810px', top: 360 + ((index / 2) * 50) - (index / 2) + 'px' }">
                  <div class="dbfxDataBoxTitle">
                    <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index + 1].subjectName }}</span>
                  </div>
                  <div class="dbfxDataBoxValue">
                    <span class="dbfxDataBoxValuespan">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index + 1].subjectValStr }}</span>
                  </div>
                </div>
              </template>

              <template v-else-if="index + 1 >= selectData.averageNonCurrentAssets.duPontFormulaInfoEleList.length">
                <div class="dbfxDataBox" :style="{ left: '650px', top: 360 + ((index / 2) * 50) - (index / 2) + 'px' }">
                  <div class="dbfxDataBoxTitle">
                    <span class="dbfxDataBoxValuespan" style="font-weight: 800;">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index].subjectName }}</span>
                  </div>
                  <div class="dbfxDataBoxValue">
                    <span class="dbfxDataBoxValuespan">{{
                      selectData.averageNonCurrentAssets.duPontFormulaInfoEleList[index].subjectValStr }}</span>
                  </div>
                </div>
                <div class="dbfxDataBox"
                  :style="{ height: '25px', left: '810px', top: 360 + ((index / 2) * 50) - (index / 2) + 'px' }">
                  <div class="dbfxDataBoxTitle">
                    <span class="dbfxDataBoxValuespan" style="font-weight: 800;">···</span>
                  </div>
                </div>
              </template>

            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
    
<script>
import { linkName, sendRequestCompany2 } from '../../../../static/js/util';

export default {
  props: [
    'comCode'
  ],
  data() {
    return {
      dataList: [],
      dataIndex: 0,
      selectData: {
        "assetLiabilityRatio":
        {
          "subjectName": "资产负债率",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "averageCurrentAssets":
        {
          "subjectName": "平均流动资产",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "averageNonCurrentAssets":
        {
          "subjectName": "平均非流动资产",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "averageTotalAssets":
        {
          "subjectName": "平均资产总额",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "averageTotalLiabilities":
        {
          "subjectName": "平均负债总额",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "dataIndex": 0,
        "equityMultiplier":
        {
          "subjectName": "权益乘数",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "grossOperatingIncome":
        {
          "subjectName": "营业总收入",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "netOperatingMargin":
        {
          "subjectName": "营业净利润率",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "netProfit":
        {
          "subjectName": "净利润",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "netProfitOfParentCompany":
        {
          "subjectName": "归属母公司股东的净利润占比",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "profitMarginOfTotalAssets":
        {
          "subjectName": "总资产净利率",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "reportDate": "",
        "returnOnEquity":
        {
          "subjectName": "净资产收益率",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "totalCost":
        {
          "subjectName": "成本总额",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "totalRevenue":
        {
          "subjectName": "收入总额",
          "subjectVal": 0,
          "subjectValStr": "0",
        },
        "turnoverOfTotalAssets":
        {
          "subjectName": "总资产周转率",
          "subjectVal": 0,
          "subjectValStr": "0",
        }
      },

      timeList: [],
      selectTimeListOne: [
        '一季报',
        '中报',
        '三季报',
        '年报',
      ],
      selectTimeListTwo: [],
      timeIndexOne: 0,
      timeIndexTwo: 0,

      loading: 0,

      lineYHeightNum1: 43,
      lineXTopNum1: 392,
      topEndNum1: 360,

      lineYHeightNum2: 69,
      lineXTopNum2: 418,
      topEndNum2: 360,
      periodExpenses2: {
        "subjectName": "期间费用",
        "subjectVal": 0,
        "subjectValStr": "0",
      },
      perExpList2: [],
      perLineYHeightNum2: 1,
      perLineXTopNum2: 421,

      lineYHeightNum3: 42,
      lineXTopNum3: 392,
      topEndNum3: 360,

      lineYHeightNum4: 17,
      lineXTopNum4: 367,
      topEndNum4: 360,
    };
  },
  mounted() {
    // this.comCode = this.$route.query.comCode;
    // this.name = this.$route.query.comName;

    this.getData();
  },
  methods: {
    getData() {
      let url = '/report/reportFinance/' + this.comCode + '/4';
      // var loadmsg = this.$message('加载中');
      sendRequestCompany2(url, 'get', null, res => {
        if (res.data.code == 0 && res.data.data.resultJson != undefined && res.data.data.resultJson.length > 0) {
          // loadmsg.close();
          // this.$message({
          //     showClose: true,
          //     message: '加载完成',
          //     type: 'success',
          //     duration: 1000
          // });

          var resultJson = res.data.data.resultJson;
          var jsonData = JSON.parse(resultJson);

          //选出'一季报'
          var list = [];
          jsonData.financeReportDates.map(item => {
            if (item.dateType == '1') {
              list.push(item);
            }
          });

          //取'一季报'下第一条, 取到对应杜邦分析图
          var index = list[0].dataIndex;
          var dataTemp = {};
          jsonData.duPontFormulaInfos.map(item => {
            if (item != undefined && item.dataIndex == index) {
              dataTemp = item;
            }
          })

          this.dataList = jsonData.duPontFormulaInfos;
          this.dataIndex = index;
          this.selectData = dataTemp;
          this.timeList = jsonData.financeReportDates;
          this.loading = 1

          this.resetView();

          // 时间选择第二行--年份
          var listTwo = [];
          this.timeList.map(item => {
            if (item.dateType == '1') {
              listTwo.push(item);
            }
          });
          this.selectTimeListTwo = listTwo;
          this.selectTimeTwo(0, listTwo[0]);

        } else {
          // loadmsg.close();
          this.$message({
            showClose: true,
            message: '暂无数据',
            type: 'warning'
          });
        }
      }, error => {
        // loadmsg.close();
        this.$message({
          showClose: true,
          message: '加载出错',
          type: 'error'
        });
        console.log(error);
      })
    },
    // 重置动态部分内容
    resetView() {
      // 收入总额细项
      try {
        var num1 = this.selectData.totalRevenue.duPontFormulaInfoEleList.length;
        if (num1 > 0) {
          this.lineYHeightNum1 = 20 + (num1 * 50) + 23;
          this.lineXTopNum1 = 350 + this.lineYHeightNum1;
          this.topEndNum1 = 360 + (num1 * 50);
        }
      } catch (e) { }

      // 成本总额细项
      try {
        var num2 = this.selectData.totalCost.duPontFormulaInfoEleList.length;
        if (num2 > 0) {
          //期间费用
          for (var i = 0; i < this.selectData.totalCost.duPontFormulaInfoEleList.length; i++) {
            if (this.selectData.totalCost.duPontFormulaInfoEleList[i].eleType === 3) {
              this.periodExpenses2 = this.selectData.totalCost.duPontFormulaInfoEleList[i];
              this.perExpList2 = this.periodExpenses2.duPontFormulaInfoEleList;
              break;
            }
          }

          this.lineYHeightNum2 = 20 + (num2 * 50) + 23;
          this.lineXTopNum2 = 350 + this.lineYHeightNum2;
          this.topEndNum2 = 360 + (num2 * 50);
          this.perLineYHeightNum2 = this.perExpList2.length * 50;
          this.perLineXTopNum2 = 420 + this.perLineYHeightNum2 - 1;

          if (this.lineYHeightNum2 < this.perLineYHeightNum2 + 75) {
            this.lineYHeightNum2 = this.perLineYHeightNum2 + 75;
            this.lineXTopNum2 = 350 + this.lineYHeightNum2;
          }
        }
      } catch (e) { }

      // 平均流动资产细项
      try {
        var num3 = this.selectData.averageCurrentAssets.duPontFormulaInfoEleList.length;
        if (num3 > 0) {
          this.lineYHeightNum3 = 20 + (num3 * 50) + 23;
          this.lineXTopNum3 = 350 + this.lineYHeightNum3;
          this.topEndNum3 = 360 + (num3 * 50);
        }
      } catch (e) { }

      // 平均非流动资产细项
      try {
        var num4 = this.selectData.averageNonCurrentAssets.duPontFormulaInfoEleList.length;
        if (num4 > 0) {
          var lineNum = Math.ceil(num4 / 2);
          this.lineYHeightNum4 = 20 + (lineNum * 50) - 3;
          if (lineNum == num4 / 2) {
            this.lineYHeightNum4 = 20 + (lineNum * 50) + 23;
          }
          this.lineXTopNum4 = 350 + this.lineYHeightNum4;
          this.topEndNum4 = 360 + (lineNum * 50);
        }
      } catch (e) { }
    },
    // 选择季度
    selectTimeOne(index) {

      this.timeIndexOne = index;
      this.timeIndexTwo = 0

      //换季度后默认选中第一个年份
      var listTwo = [];
      if (index == 0) {
        this.timeList.map(item => {
          if (item.dateType == '1') {
            listTwo.push(item);
          }
        });
      } else if (index == 1) {
        this.timeList.map(item => {
          if (item.dateType == '2') {
            listTwo.push(item);
          }
        })
      } else if (index == 2) {
        this.timeList.map(item => {
          if (item.dateType == '3') {
            listTwo.push(item);
          }
        })
      } else if (index == 3) {
        this.timeList.map(item => {
          if (item.dateType == '0') {
            listTwo.push(item);
          }
        })
      }

      this.selectTimeListTwo = listTwo;
      this.selectTimeTwo(0, listTwo[0]);

    },
    // 选择年份
    selectTimeTwo(index, item) {
      // console.log(item)
      if (item == undefined || index == undefined) {
        return;
      }

      var dataIndexTemp = item.dataIndex;
      var dataTemp = {};
      this.dataList.map(item => {
        if (item.dataIndex == dataIndexTemp) {
          dataTemp = item;
        }
      })

      this.timeIndexTwo = index;
      this.selectData = dataTemp;
      this.dataIndex = dataIndexTemp;

      this.resetView();
    }
  }
};
</script>
    
<style scoped>
.selectButton {
  margin-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}

.scroll {
  width: 100%;
}

.dbfxBox {
  width: 950px;
  height: 900px;
  position: relative;
  z-index: 1;
  background-color: #fff;
}

.dbfxDataBox {
  width: 130px;
  height: 48px;
  position: absolute;
  z-index: 3;
  border: 2px solid #dddd;
  flex-direction: column;
  text-align: center;
}

.dbfxDataBoxTitle {
  flex: 1;
  background-color: #dddddd;
}

.dbfxDataBoxValue {
  flex: 1;
}

.dbfxDataBoxValueText {
  /* span-align: center; */
  line-height: 22px;
  /*color: #3a3a3a;*/
}

.dbfxLineX {
  height: 2px;
  position: absolute;
  z-index: 2;
  background-color: #97bc72;
}

.dbfxLineY {
  width: 2px;
  position: absolute;
  z-index: 2;
  background-color: #97bc72;
}

.dbfxSymbol {
  font-size: 40px;
  font-weight: 400;
  line-height: 50px;
  color: #3a3a3a;
}
</style>